import { find } from "../utils/dom";
import IMask from "imask";
import axios from "axios";

const Contato = () => {
  const page = find("[js-page='contato']");
  if (!page) return;

  const BASEURL = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
  const CONTENTFORM = find('[js-content-form]');
  const CONTATOLOAD = find('[js-contato-load]');

  const onlyDigits = (v) => String(v || "").replace(/\D/g, "");
  const isFieldEmpty = (v) => v == null || String(v).trim() === "";

  const phoneLocalError = (value) => {
    const d = onlyDigits(value);
    if (d.length < 2) return "Informe o DDD (2 dígitos) e o número.";
    const local = d.slice(2);
    if (local.length === 0) return "Informe o número após o DDD.";
    if (local.length < 9) return `Faltam ${9 - local.length} dígito(s) no número.`;
    if (local.length > 9) return "Número tem dígitos demais.";
    if (local[0] !== "9") return "O número de celular deve começar com 9.";
    return "";
  };

  CONTENTFORM?.classList.remove("not_visibled");
  CONTATOLOAD?.classList.add("loaded");

  const formContato = find("#wf-form-Contact");
  if (!formContato) return;

  const phoneInput = find("#Contact-Phone-2");
  const messageInput = find("#Contact-Message");

  if (phoneInput) {
    IMask(phoneInput, {
      mask: "(00) 00000-0000",
    });
  }

  phoneInput?.addEventListener("input", () => {
    const msg = phoneLocalError(phoneInput.value);
    phoneInput.setCustomValidity(msg);
  });
  phoneInput?.addEventListener("blur", () => {
    const msg = phoneLocalError(phoneInput.value);
    phoneInput.setCustomValidity(msg);
    if (msg) phoneInput.reportValidity();
  });

  messageInput?.addEventListener("input", () => {
    messageInput.setCustomValidity(
      isFieldEmpty(messageInput.value) ? "Descreva seu caso para continuar." : ""
    );
  });

  formContato.addEventListener("submit", async (e) => {
    e.preventDefault();

    const dados = new FormData(e.target);
    const messageError = find("[js-error-message]");
    const messageSuccess = find("[js-success-message]");
    const buttonClosedSuccess = messageSuccess?.querySelector(".close-button");
    const submitButton = formContato.querySelector("input[type='submit']");

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.value = submitButton.getAttribute("data-wait") || "Enviando...";
    }

    messageError?.classList.remove("is_visible");

    const phoneRaw = String(dados.get("Contact-Phone") || "");
    const phoneDigits = onlyDigits(phoneRaw); 

    phoneInput?.setCustomValidity("");
    messageInput?.setCustomValidity("");

    let hasError = false;

    const requiredNames = [
      "Contact-Name",
      "Benefit-Category",
      "Health-Category",
      "Contact-Email",
      "Contact-Message",
      "Contact-Phone",
    ];
    requiredNames.forEach((name) => {
      if (isFieldEmpty(dados.get(name))) hasError = true;
    });

    const telMsg = phoneLocalError(phoneRaw);
    if (telMsg) {
      hasError = true;
      phoneInput?.setCustomValidity(telMsg);
      phoneInput?.reportValidity();
    }

    if (isFieldEmpty(dados.get("Contact-Message"))) {
      hasError = true;
      messageInput?.setCustomValidity("Descreva seu caso para continuar.");
      messageInput?.reportValidity();
    }

    if (hasError) {
      messageError?.classList.add("is_visible");
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.value = "Análise gratuita";
      }
      return;
    }

    const dadosForm = {
      nome: dados.get("Contact-Name"),
      telefone: phoneDigits,
      beneficio: dados.get("Benefit-Category"),
      portadorDoenca: dados.get("Health-Category"),
      email: dados.get("Contact-Email"),
      message: dados.get("Contact-Message"),
    };

    try {
      const response = await axios.post(`/fale-conosco/`, dadosForm);
      if (response?.status === 200) {
        messageSuccess?.classList.add("is_visible");
        formContato.reset();
      } else {
        messageError?.classList.add("is_visible");
      }
    } catch (error) {
      console.error("Erro ao enviar o formulário:", error);
      messageError?.classList.add("is_visible");
    } finally {
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.value = "Análise gratuita";
      }
    }

    buttonClosedSuccess?.addEventListener("click", () => {
      messageSuccess?.classList.remove("is_visible");
    });
  });

  const screenMobile = window.matchMedia("(max-width: 990px)");
  if (screenMobile.matches) {
    window.location.href = `${BASEURL}#w-node-d15efeed-5242-799c-6d90-cd6cf88e7112-383a66df`;
  }
};

export default Contato;
